import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isUndefined from 'lodash.isundefined';

import EventAdvertisementLayout from './EventAdvertisementLayout';
import CartUpsellEventModal from '@modals/CartUpsellEventModal';

import useEventFromAPI from '@hooks/apiLegacy/useEventFromAPI';
import useEventFromGraph from '@hooks/useEventFromGraph';
import useIsCartMultiCurrency from '@hooks/useIsCartMultiCurrency';
import MultiCurrencyCartModal from '@modals/MultiCurrencyCartModal';

const EventAdvertisement = ({ eventCode, boosted }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [displayMultiCurrencyModal, setDisplayMultiCurrencyModal] = useState(false);
    const { event: eventFromAPI } = useEventFromAPI({ code: eventCode });
    const { event: eventFromGraphQL } = useEventFromGraph({
        code: eventCode,
        fields: 'recordId code image',
    });
    const { isCartMultiCurrency } = useIsCartMultiCurrency({ locale: eventFromAPI?.locale });

    if (isUndefined(isCartMultiCurrency)) {
        return null;
    }

    if (!eventFromAPI) {
        return null;
    }

    return (
        <div>
            {displayMultiCurrencyModal ? (
                <MultiCurrencyCartModal
                    isOpen={displayMultiCurrencyModal}
                    onClose={() => setDisplayMultiCurrencyModal(false)}
                />
            ) : null}
            <EventAdvertisementLayout
                eventFromAPI={eventFromAPI}
                eventFromGraph={eventFromGraphQL}
                onAddClick={() => {
                    if (isCartMultiCurrency) {
                        setDisplayMultiCurrencyModal(true);
                        return;
                    }

                    setDisplayMultiCurrencyModal(false);
                    setIsModalOpen(true);
                }}
                boosted={boosted}
            />

            <CartUpsellEventModal eventCode={eventCode} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
    );
};

EventAdvertisement.propTypes = {
    eventCode: PropTypes.string.isRequired,
    boosted: PropTypes.number,
};

export default EventAdvertisement;
